<template>
  <div id="addTips">
    <pt-modal :title="$t('deal.dealDetails.dealDetail.remind')" :visible="visible" :width="800" @cancel="hide" @ok="submit"
    :loading="loading">
      <div slot="content">
        <div class="formDiv">
          <a-form :form="reminderForm" layout="vertical">
            <div style="padding: 20px 20px 0 20px">
              <a-form-item v-show="false">
                <a-input v-decorator="decorators.id"></a-input>
              </a-form-item>
              <a-row :gutter="20">
                <a-col :span="8">
                  <a-form-item :label="$t('deal.tips.taskType')" class="required">
                    <pt-select v-decorator="decorators.taskType" :allow-clear="false">
                      <a-select-option v-for="o in taskTypes" :key="o.wordKey" :value="o.wordKey">{{$t('deal.dealDetails.customerRecordTypes.' + o.wordKey)}}</a-select-option>
                    </pt-select>
                  </a-form-item>
                </a-col>
                <a-col :span="16">
                  <a-form-item :label="$t('deal.tips.participant')" class="required">
                    <pt-user-select v-decorator="decorators.accountIds" :placeholder="$t('user.tips.select')"  style="width: 150px" mode="multiple" maxTagCount="3"></pt-user-select>
                  </a-form-item>
                </a-col>
                <a-col :span="8">
                  <a-form-item :label="$t('deal.tips.startTime')">
                    <a-date-picker :showTime="{format:'HH:mm'}" v-decorator="decorators.startTime" style="width:100%">
                    </a-date-picker>
                  </a-form-item>
                </a-col>
                <!--<a-col :span="8">-->
                <!--<a-form-item :label="$t('deal.tips.endTime')">-->
                <!--<a-date-picker v-decorator="decorators.endTime" style="width:100%">-->
                <!--</a-date-picker>-->
                <!--</a-form-item>-->
                <!--</a-col>-->
                <a-col :span="8">
                  <a-form-item :label="$t('deal.tips.lastHours')">
                    <pt-select v-decorator="decorators.lastHours" :allowClear="false">
                      <a-select-option v-for="o in lastHoursOptions" :key="o.wordKey" :value="o.wordKey">{{o.wordValue}}</a-select-option>
                    </pt-select>
                  </a-form-item>
                </a-col>
                <a-col :span="8">
                  <a-form-item :label="$t('deal.tips.tipsTime')">
                    <pt-select v-decorator="decorators.advanceDays" :allowClear="false">
                      <a-select-option v-for="o in advanceDaysOptions" :key="o.wordKey" :value="o.wordKey">{{o.wordValue}}</a-select-option>
                    </pt-select>
                    <!--<a-date-picker v-decorator="decorators.lastHours" style="width:100%"></a-date-picker>-->
                  </a-form-item>
                </a-col>
                <a-col :span="24">
                  <a-form-item :label="$t('deal.tips.content')">
                    <a-textarea :rows="3" v-decorator="decorators.content" :placeholder="$t('deal.tips.contentTips')"></a-textarea>
                  </a-form-item>
                </a-col>
              </a-row>
            </div>
          </a-form>
        </div>
      </div>
    </pt-modal>
  </div>
</template>

<script>
  import reminderApi from '@/api/work/reminder'
  import { getDatadictChildsByPath } from '@/api/sys/datadict'
  export default {
    name: 'addTips',
    props: {
      loading:{
        type:Boolean,
        default: false
      },
      dealId:{
        type:String,
        default:null
      },
      pursuitsId:{
        type:String,
        default:null
      },
      visible:{
        type:Boolean,
        default: false
      },
      defaultValue:{
        type: Object,
        default: ()=>{ return null }
      }
    },
    data() {
      return {
       // loading: false,
        selectUserVisible:false,
        lastHoursOptions:[],
        taskTypes:[],
        advanceDaysOptions:[],
        reminderForm: this.$form.createForm(this,{}),
        decorators:{
          id:['id',{}],
          businessId:['businessId',{}],
          accountIds:['accountIds',{rules:[{required:true,message:this.$t('deal.tips.errorInfo.participant')}],initialValue:[this.$store.getters.userInfo.accountDO.id]}],
          advanceDays:['advanceDays',{rules:[],initialValue:'1'}],
          remindType:['remindType',{}],
          stopRemind:['stopRemind',{}],
          lastHours:['lastHours',{rules:[],initialValue:'1'}],
          startTime:['startTime',{initialValue:this.$moment().hour(9).minute(0).second(0).millisecond(0).add(1,'day')}],
          endTime:['endTime',{}],
          remindDate:['remindDate',{}],
          taskType:['taskType',{initialValue:1}],
          content:['content',{rules:[{max: 200, message: this.$t('deal.tips.errorInfo.contentMax'), trigger: 'blur'}]}],
        }
      }
    },
    mounted() {
      this.init()
    },
    methods: {
      init(){
        this.initLastHoursOptions()
        this.initAdvanceDaysOptions()
        this.initTaskTypes()
      },
      initLastHoursOptions(){
        let options = this.$t('deal.tips.lastHoursOptions')
        let lastHoursOptions = []
        for(let p in options){
          lastHoursOptions.push({wordKey:p,wordValue:options[p]})
        }
        this.lastHoursOptions = lastHoursOptions
      },
      initAdvanceDaysOptions(){
        let options = this.$t('deal.tips.advanceDaysOptions')
        let advanceDaysOptions = []
        for(let p in options){
          advanceDaysOptions.push({wordKey:p,wordValue:options[p]})
        }
        this.advanceDaysOptions = advanceDaysOptions
      },
      initTaskTypes(){
        getDatadictChildsByPath('system.business_key.customer_record_type_set').then(res => {
          this.taskTypes = res.data
          this.taskTypes.forEach(e=>{
            e.wordKey = parseInt(e.wordKey)
          })
        })
        let customerRecordDO = this.reminderForm.getFieldsValue()
        console.log("跟进记录",customerRecordDO)
      },
      hide(){
        this.$emit('hide')
      },
      setDefaultValue(defaultValue){
        let value = JSON.parse(JSON.stringify(defaultValue))
        value.startTime = this.$moment(value.startTime)
        value.advanceDays = value.advanceDays + ''
        value.remindType = value.remindType + ''
        value.lastHours = value.lastHours + ''
        this.$nextTick(()=>{
          this.reminderForm.setFieldsValue(value)
        })
      },
      submit(){
        this.loading = true
        this.reminderForm.validateFieldsAndScroll(err=>{
          if(!err){
            let reminderDO = this.reminderForm.getFieldsValue()
            reminderDO.businessId = this.dealId != null ? this.dealId : this.pursuitsId
            reminderDO.remindType = this.dealId != null ? '1' : '2'
            reminderApi.insert(reminderDO).then(res=>{
              if(res.code == 1){
                this.$emit('saveSuccess')
                this.$message.success(res.message)
              }else{
                this.$message.error(res.message)
              }
            })
           // this.loading = false
          }else{
            this.loading = false
          }
        })
      }
    }
  }
</script>

<style scoped lang="less">
  /*.ant-form-item{*/
    /*padding: 0 10px;*/
  /*}*/
  .formDiv{
    background: rgba(248,249,251,0.62);
    border-radius: 4px;
  }
</style>